module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-01-939de72f3032765c5da033a14f55277e.jpg";